import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useContextManager } from 'apps/context/hooks';
import { useChatControl } from 'libs/rendering/hooks';

import Panel from '../panel/panel';

import { OverflowWrapper } from './styles';

const LargePanel = props => {
  const { addCloseButton = true, children, collapseHandler } = props;
  const chatControl = useChatControl();
  const contextManager = useContextManager();

  return (
    <Panel
      large
      removeHeader
      addCloseButton={addCloseButton}
      isOpen
      position='right'
      chatVisible={contextManager && chatControl?.chatVisible}
      collapseAction={collapseHandler}
    >
      <OverflowWrapper>{children}</OverflowWrapper>
    </Panel>
  );
};

export default observer(LargePanel);

LargePanel.propTypes = {
  addCloseButton: PropTypes.bool,
  children: PropTypes.object,
  collapseHandler: PropTypes.func,
};
